import { JobsTypes, SingleJobsType } from "./jobsType";

export const jobsReducer = {
    resetError: (state: JobsTypes) => {
        state.error = null;
        state.message = "";
    },
    resetSuccess: (state: JobsTypes) => {
        state.success = null;
    },
    resetSharedJobSuccess: (state: JobsTypes) => {
        state.sharedJobSuccess = null;
    },
    resetMessage: (state: JobsTypes) => {
        state.message = "";
    },
    resetStatusCode: (state: JobsTypes) => {
        state.statusCode = null;
    },
    resetFetching: (state: JobsTypes) => {
        state.fetching = false;
    },
    resetJobsTypeList: (state: JobsTypes) => {
        state.jobsTypeList = [];
    },
    resetNonRecurringJobsList: (state: JobsTypes) => {
        state.NonRecurringJobsList = [];
    },
    resetSingleJobsType: (state: JobsTypes) => {
        state.singleJobsType = {} as SingleJobsType;
    },
    resetRecurringJobsDetailsList: (state: JobsTypes) => {
        state.singleRecurringJobsDetails = {};
    },
    resetTotalCount: (state: JobsTypes) => {
        state.jobsTypeListTotalCount = 0;
    },
    resetJobsTotalCount: (state: JobsTypes) => {
        state.totalJobsCount = 0;
    },
    resetTotalRecurringJobsListCount: (state: JobsTypes) => {
        state.totalRecurringJobsListCount = 0;
    },
    resetJobsList: (state: JobsTypes) => {
        state.jobsList = [];
    },
    resetFutureJobsList: (state: JobsTypes) => {
        state.futureJobsList = [];
    }
    ,
    resetSingleJobs: (state: JobsTypes) => {
        state.singleJobs = {};
    },
    resetRecurringResponsiblePeople: (state: JobsTypes) => {
        state.recurringResponsiblePeople = [];
    },
    resetJobProgressCommentsSuccess: (state: JobsTypes) => {
        state.jobProgressCommentsSuccess = null
    },
    resetJobProgressCommentsListing: (state: JobsTypes) => {
        state.jobProgressCommentsList = [];
    },
    resetDocumentsLinkList: (state: JobsTypes) => {
        state.documentsLinkList = [];
    },
    resetAssignedClientsOpenJobsList: (state: JobsTypes) => {
        state.assignedClientsOpenJobsList = [];
    },
    resetAssignedClientsShareOpenJobsList: (state: JobsTypes) => {
        state.assignedClientsShareOpenJobsList = [];
    },
    resetUniqueCheckMessage: (state: JobsTypes) => {
        state.uniqueCheckMessage = "";
    },
    resetUniqiueCheckFetching: (state: JobsTypes) => {
        state.uniqueCheckFetching = false;
    },
    resetUniqueCheckSuccess: (state: JobsTypes) => {
        state.uniqueCheckSuccess = null;
    },
    resetUniqueCheckStatusCode: (state: JobsTypes) => {
        state.uniqueCheckStatusCode = null;
    },
    resetJobChecklistData: (state: JobsTypes) => {
        state.jobChecklistData = [];
    },
    resetJobChecklistSingleData: (state: JobsTypes) => {
        state.jobChecklistSingleData = null;
    },
    resetJobCheckTotalCount: (state: JobsTypes) => {
        state.jobChecklistCount = 0;
    },
    resetAllOpenJobChecklistData: (state: JobsTypes) => {
        state.allOpenJobChecklistData = [];
    },
    resetAllOpenJobChecklistSingleData: (state: JobsTypes) => {
        state.allOpenJobChecklistSingleData = null;
    },
    resetAllOpenJobCheckTotalCount: (state: JobsTypes) => {
        state.allOpenJobChecklistCount = 0;
    },
    resetAllCommentDueTomorrowListData: (state: JobsTypes) => {
        state.allCommentDueTomorrowListData = [];
    },
    resetAllCommentDueTomorrowCount: (state: JobsTypes) => {
        state.allCommentDueTomorrowCount = 0;
    },
    // 
    resetRecurringJobReportList: (state: JobsTypes) => {
        state.recurringJobReportList = [];
    },
    resetRecurringJobReportTotalCount: (state: JobsTypes) => {
        state.recurringJobReportTotalCount = 0;
    }
}




